export type DateOfBirth = string;
export const PATTERN =
  /^((0[1-9])|([1-2][0-9])|(3[0-1]))\.((0[1-9])|(1[0-2]))\.((19|20)[0-9]{2})$/;
